'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component('mdi-diamond-icon', {
  template: '<svg :class="[\'mdi-icon\', className]" :width="width" :height="height" :viewBox="viewBox"><path  d="M 16,9L 19,9L 14,16M 10,9L 14,9L 12,17M 5,9L 8,9L 10,16M 15,4L 17,4L 19,7L 16,7M 11,4L 13,4L 14,7L 10,7M 7,4L 9,4L 8,7L 5,7M 6,2L 2,8L 12,22L 22,8L 18,2L 6,2 Z "/></svg>',
  props: {
    className: [Object, Array, String],
    width: {
      type: Number,
      'default': 24
    },
    height: {
      type: Number,
      'default': 24
    },
    viewBox: {
      type: String,
      'default': '0 0 24 24'
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/mdi-vue/DiamondIcon.js
// module id = BSnP
// module chunks = 0